import { DynamicGrapesJsComponent } from '@peerless/data-access/strapi';
import React from 'react';
import { Box } from '@mui/material';
import { withSectionLayout } from './SectionLayout';

interface Props {
  data: DynamicGrapesJsComponent;
}

const defaultContent = { css: '', html: '' };

const removeBodyTags = (htmlString: string): string => {
  return htmlString.replace(/<\/?body[^>]*>/g, '');
};

export const _DynamicGrapesJsContent: React.FC<Props> = ({ data }) => {
  const { css, html } = data?.content ?? defaultContent;
  return (
    <Box className="grapes-js-content-root">
      <style dangerouslySetInnerHTML={{ __html: css }} />
      <div dangerouslySetInnerHTML={{ __html: removeBodyTags(html) }} />
    </Box>
  );
};

export const DynamicGrapesJsContent = withSectionLayout(_DynamicGrapesJsContent);
